module.exports = __webpack_public_path__ + "static/media/measure_icon.def2f513.svg";